// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__GQ3jW","l20-1":"Spinner_l20-1__fGUfu","l20-2":"Spinner_l20-2__eNRaT"};